import { RestService } from './ResyService';
import { UsersModel } from '@/models';
import { CustomerEndPoints } from './config';

export class UserService extends RestService {

    addUser(data: UsersModel) {
        const body = JSON.stringify({
            'user_display_name': data.name,
            'user_name': data.username,
            'user_email': data.email,
            'user_password': data.password,
        })
        return this.post(CustomerEndPoints.AddCustomer, body);
    }

    getAllUsers() {
        return this.get(CustomerEndPoints.Users);
    }

}